import React, { memo, forwardRef } from "react";
const SvgDisjunction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M7.594 6.087a1 1 0 011.32.507L16 22.538l7.087-15.944a1 1 0 111.827.813l-8 18a1 1 0 01-1.827 0l-8-18a1 1 0 01.507-1.32z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgDisjunction.displayName = "SvgDisjunction";
const MemoForwardRef = memo(SvgDisjunction);
export default MemoForwardRef;
